import * as React from "react";

class DialogMText extends React.Component {
  constructor(props: {}) {
    super(props);
  }

  public render() {
    return (
      <svg
        className="dialogM-text dialogLMNO-text"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        x="0px"
        y="0px"
        viewBox="0 0 140.7 106.1"
      >
        <g>
          <path
            fill="#fbf7ec"
            d="M36.48,53.68a19.07,19.07,0,0,0,.8-4.5l1.5.2a24.06,24.06,0,0,1-.8,4.8Zm15.6-4.9v12.8H50v-.7h-4.8v.8h-2v-9.9l-1.5.7a24.62,24.62,0,0,0-.8-2.7v11.8h-2v-16h2v3.3l1.1-.5a18.44,18.44,0,0,1,1.2,3.2v-3h2.9c.2-1,.4-2.1.5-3l2.4.2c-.3.9-.5,1.9-.8,2.7h3.9Zm-6.9,2v3.1H50v-3.1ZM50,59v-3.3h-4.8V59Z"
          />
          <path
            fill="#fbf7ec"
            d="M53.58,53.68a19.07,19.07,0,0,0,.8-4.5l1.5.2a24.06,24.06,0,0,1-.8,4.8Zm15.7-4.9v12.8h-2.1v-.7h-4.8v.8h-2v-9.9l-1.5.7a24.62,24.62,0,0,0-.8-2.7v11.8h-2v-16h2v3.3l1.1-.5a18.44,18.44,0,0,1,1.2,3.2v-3h2.9c.2-1,.4-2.1.5-3l2.4.2c-.3.9-.5,1.9-.8,2.7h3.9Zm-7,2v3.1h4.8v-3.1Zm4.9,8.2v-3.3h-4.8V59Z"
          />
          <path
            fill="#fbf7ec"
            d="M81.78,48.88c.9.9,2.7,1.3,5.1,1.5a5.72,5.72,0,0,0-1.1,1.6,8.35,8.35,0,0,1-4.5-1.7c-.7.8-2.1,1.4-4.9,1.7a3.38,3.38,0,0,0-.7-1.1h-4.5v-1.6h5.2v1c3.3-.3,3.7-1.1,3.7-1.7v-.3h-1a9.83,9.83,0,0,1-1.2,1.5,7.84,7.84,0,0,0-1.5-1,7.55,7.55,0,0,0,2-3l1.8.4c-.1.3-.2.5-.3.8h4.9l.3-.1,1.4.4a12,12,0,0,1-1.6,2.7l-1.6-.6a8.79,8.79,0,0,0,.6-1H82v.5Zm.4,10c1.6.6,3.3,1.3,4.3,1.8l-1.8,1.1a28.22,28.22,0,0,0-4.5-2l1-.8h-4.8l1.5.7a22.74,22.74,0,0,1-5.3,2.2c-.3-.4-1.1-1.1-1.5-1.5a20,20,0,0,0,4.7-1.4h-2.5V52h11.5v7h-2.6Zm-6.4-10.8h-4.4v-1.5h4.4Zm-.5,5.8h7.4v-.7h-7.4Zm0,1.9h7.4v-.7h-7.4Zm0,1.9h7.4v-.8h-7.4Z"
          />
          <path
            fill="#fbf7ec"
            d="M94.38,50.28h-6.3v-1.6h2.8a21.4,21.4,0,0,0-1-2.2l1.5-.7a12,12,0,0,1,1.1,2.3l-1,.6h3v1.6Zm-5.6,2.3v-1.5h5v1.5Zm0,.7h5v1.5h-5Zm5,7.6h-3.4v.7h-1.5v-5.9h5v5.2Zm-3.4-3.6v1.9h1.8v-1.9Zm11.9-10.6c-.2,5.6-.1,12.7.5,12.9a7.1,7.1,0,0,0,.2-2.2,11.07,11.07,0,0,0,1.1,1.6c-.3,2.5-1.1,3-2.2,2.6-1.6-.7-1.6-6.6-1.6-13h-2.1v4.5h1.7V55h-1.6v6.7h-1.9V55h-1.9v-1.9h1.9v-4.5h-1.7v-1.9Z"
          />
        </g>
      </svg>
    );
  }
}

export default DialogMText;



// WEBPACK FOOTER //
// ./src/rabbitCity/components/DialogMText.tsx